module.exports = __webpack_public_path__ + "static/media/29_tn.9c0c76a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/29_tn.jpg
// module id = 243
// module chunks = 0